import PropTypes from "prop-types";
import styled from "styled-components";
import tw from "twin.macro";

const Caption = styled.div`
  figure {
    ${tw`text-xs max-w-4xl mx-auto px-4 md:px-0 md:text-sm py-2 text-gray-700`}
  }
`;

const CaptionAndAttributionBlock = ({ caption, attribution, gallery }) => (
  <Caption>
    <figure>
      {caption && <span className="mr-1">{caption}</span>}
      {attribution && (
        <span className="italic">{`Photo${gallery} by ${attribution}.`}</span>
      )}
    </figure>
  </Caption>
);

CaptionAndAttributionBlock.propTypes = {
  caption: PropTypes.string,
  attribution: PropTypes.string,
};

export default CaptionAndAttributionBlock;
